import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, CloseBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import { equipmentsMng } from '../api/equipmentsMng';
import EquipmentForm from './EquipmentForm';

const useStyles = makeStyles((theme) => ({
  container: {},
}));

function AddEquipmentDialog(props) {
  const classes = useStyles();
  const theme = useTheme();

  const { open, onClose, onAdd = () => {}, factory } = props;

  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState();

  const createEquipment = async () => {
    setLoading(true);
    const equipment = { ...formData };
    console.log(equipment);
    if (factory) {
      equipment.factoryId = factory._id;
    }

    delete equipment.isValid;
    try {
      await equipmentsMng.addEquipment(equipment);
      onAdd();
      _onClose();
      toast.success('Equipment added successfully', {
        autoClose: 900,
      });
    } catch (e) {
      toast.error('Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const _onClose = () => {
    setFormData({});
    onClose();
  };

  if (!open) {
    return null;
  }

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        Add Equipment
        <CloseBtn
          onClick={() => {
            onClose();
          }}
        />
      </DialogTitle>
      <DialogContent>
        <EquipmentForm
          factory={factory}
          onChange={(data) => {
            console.log('on change');
            console.log(data);
            setFormData({ ...data });
          }}
          values={formData}
        />
        <div
          style={{
            marginBottom: '20px',
            marginTop: '10px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || !formData || !formData.isValid}
            label={<span>Add Equipment</span>}
            onClick={createEquipment}
            onEnter={createEquipment}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

AddEquipmentDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
};

AddEquipmentDialog.defaultProps = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: () => {},
};

export default AddEquipmentDialog;
